/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiSubscriptionStatusResponse,
  ApiVerifyReceiptDto,
  ApiVerifyReceiptResponse,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Subscription<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * @description Get a list of users subscriptions
   *
   * @tags Subscription
   * @name SubscriptionControllerGetSubscriptions
   * @summary Get a list of users subscriptions
   * @request GET:/subscription
   * @secure
   * @response `200` `void`
   */
  subscriptionControllerGetSubscriptions = (params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/subscription`,
      method: "GET",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get current subscription status from owner-subscription service
   *
   * @tags Subscription
   * @name SubscriptionControllerGetStatus
   * @summary Get subscription status
   * @request GET:/subscription/status
   * @secure
   * @response `200` `ApiSubscriptionStatusResponse` Returns the current subscription status
   * @response `403` `ApiErrorResponseDto` No active subscription or no profile found error.
   */
  subscriptionControllerGetStatus = (params: RequestParams = {}) =>
    this.request<ApiSubscriptionStatusResponse, ApiBaseError>({
      path: `/subscription/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Subscription
   * @name SubscriptionControllerVerifyReceipt
   * @summary Verify Apple App Store receipt
   * @request POST:/subscription/verify-receipt
   * @secure
   * @response `201` `ApiVerifyReceiptResponse` Receipt successfully verified
   * @response `404` `void` No subscription transaction data found.
   */
  subscriptionControllerVerifyReceipt = (
    data: ApiVerifyReceiptDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiVerifyReceiptResponse, ApiBaseError>({
      path: `/subscription/verify-receipt`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
